angular.module('app').factory('ReportUtilityServiceApi', ($http, SettingsExService, $browser, toastr, $window, ApiErrorService) => {
    let fac = {
        sims: sims,
        simSuites: simSuites,
        adjustToLocalTime: adjustToLocalTime,
        addDateToTitle: addDateToTitle,
        testers: testers,
        testerSims: testerSims,
        testerSimReport: testerSimReport
    };
    function sims(testerSimSuites) {
        let simulators = _.map(testerSimSuites, (item) => {
            return {
                Id: item.SimId,
                Name: item.SimName
            };
        });
        // If we only have one sim then that's all we need
        if (simulators.length === 1) {
            return simulators;
        }
        // @ts-ignore lodesh
        let uniqueSims = _.uniqBy(simulators, (item) => { return item.Id; });
        let sorted = _.sortBy(uniqueSims, ['Name']);
        let all = { Id: 0, Name: 'All Simulators' };
        // @ts-ignore lodesh
        return _.concat(all, sorted);
    }
    function simSuites(testerSimSuites, simId) {
        let simTestSuites = _.filter(testerSimSuites, (item) => {
            return item.SimId === simId;
        });
        let suites = _.map(simTestSuites, (item) => {
            return {
                Id: item.TestSuiteId,
                Name: item.TestSuiteName
            };
        });
        // If we only have one suite then that's all we need
        if (suites.length === 1) {
            return suites;
        }
        // @ts-ignore lodesh
        let uniqueSuites = _.uniqBy(suites, (item) => { return item.Id; });
        let sorted = _.sortBy(uniqueSuites, ['Name']);
        let all = { Id: 0, Name: 'All Test Suites' };
        // @ts-ignore lodesh
        return _.concat(all, sorted);
    }
    function addDateToTitle(title) {
        let ydm = moment().format('YYYYDDMM');
        let hhmm = moment().format('HHmm');
        let reportName = [ydm, ' ', hhmm, ' ', title].join('');
        return reportName;
    }
    function adjustToLocalTime(nodes, timezoneOffset) {
        // NB: Leaving nodes as any because this appears to be called
        //     with a number of node types, with the only common item
        // Only if we have to
        if (timezoneOffset === 0) {
            return nodes;
        }
        // tslint:disable-next-line:variable-name
        SettingsExService.getSettings().then((dateTime_response) => {
            let appSettings = dateTime_response.data;
            let DateFormats = {
                DateTimeFormat: appSettings.DateTimeFormat,
                DateFormat: appSettings.DateFormat,
                TimeFormat: appSettings.TimeFormat
            };
            // NOTE: Convert UTC time to local time and return it in place of previous time.
            angular.forEach(nodes, (node) => {
                try {
                    if (!node.isAdjusted) {
                        let ts = moment(node.Timestamp).subtract(timezoneOffset, 'm');
                        node.TimestampISO8601 = ts.format('YYYY-MM-DDTHH:mm:ss.SSSS');
                        node.TimestampPrevious = node.Timestamp;
                        node.Timestamp = ts.format(DateFormats.DateTimeFormat);
                        node.isAdjusted = true;
                    }
                }
                catch (ex) {
                }
            });
        });
        return nodes;
    }
    // TODO: Rewrite below methods or whole service using generics
    function testers(modelObject) {
        let testers = _.map(modelObject, function (item) {
            let tester = { Id: item.UserId, Name: 'No Name' };
            if ('UserDescription' in item) {
                tester.Name = item.UserDescription;
            }
            if ('Description' in item) {
                tester.Name = item.Description;
            }
            return tester;
        });
        // @ts-ignore lodash
        let uniqueTesters = _.uniqBy(testers, function (item) {
            return item.Id;
        });
        if (uniqueTesters.length === 0) {
            return [{ Id: 0, Name: 'No testers available' }];
        }
        if (uniqueTesters.length === 1) {
            return uniqueTesters;
        }
        let sorted = _.sortBy(uniqueTesters, ['Name']);
        let all = { Id: 0, Name: 'All Testers' };
        // @ts-ignore lodash
        return _.concat(all, sorted);
    }
    function testerSims(modelObject, testerId) {
        if (testerId === 0) {
            return [{ Id: 0, Name: 'All Simulators' }];
        }
        let testerSims = _.filter(modelObject, function (item) {
            return item.UserId === testerId;
        });
        let sims = _.map(testerSims, function (item) {
            return {
                Id: item.SimId,
                Name: item.SimName
            };
        });
        // If we only have one sim then that's all we need
        if (sims.length === 1) {
            return sims;
        }
        // @ts-ignore
        let uniqueSims = _.uniqBy(sims, function (item) {
            return item.Id;
        });
        let sorted = _.sortBy(uniqueSims, ['Name']);
        let all = { Id: 0, Name: 'All Simulators' };
        // @ts-ignore lodash
        return _.concat(all, sorted);
    }
    function testerSimReport(modelObject, testerId, simId) {
        let testerSimRows = _.filter(modelObject, function (item) {
            if (testerId === 0) {
                return modelObject;
            }
            if (testerId > 0 && simId === 0) {
                return item.UserId === testerId;
            }
            return item.UserId === testerId && item.SimId === simId;
        });
        // @ts-ignore lodash
        return _.sortBy(testerSimRows, [function (obj) {
                if ('UserDescription' in obj) {
                    return obj.UserDescription;
                }
                if ('Description' in obj) {
                    return obj.Description;
                }
                return obj.UserName;
            }]);
        // return _.sortBy(testerSimRows, ['UserDescription']);
    }
    return fac;
});
